import { Outlet, useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import {
    Box,
    useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Footer } from '../components/footer';

import { DashboardSidebar } from '../components/dashboard-sidebar';
import { useSettings } from "../contexts/Settings/settings-context";

import ButtonAppBar from './Navbar';
import { Helmet } from 'react-helmet-async';


const DashboardLayoutContent = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingTop: 20

}));



export const DashboardLayout = () => {
    const mdDown = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const [mobileOpen, setMobileOpen] = useState(false);
    const { settings, saveSettings } = useSettings();
    const location = useLocation();

    // Close mobile sidebar on route change
    React.useEffect(() => {
        if (mobileOpen) {
            setMobileOpen(false);
        }
    }, [location.pathname]);

    const handlePinSidebar = () => {
        saveSettings({
            ...settings,
            pinSidebar: !settings.pinSidebar
        });
    };




    return (
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            <Helmet>
                <title>Omnisell - Accounts-CRM</title>
            </Helmet>

            {!mdDown ? (
                <DashboardSidebar
                    onPin={handlePinSidebar}
                    pinned={settings.pinSidebar}
                />
            ) : (
                <DashboardSidebar
                    onMobileClose={() => setMobileOpen(false)}
                    mobileOpen={mobileOpen}
                />
            )}

            <Box
                sx={{
                    display: 'flex',
                    flex: '1 1 auto',
                    flexDirection: 'column',
                    width: '100%',
                    overflow: 'hidden',
                    ml: {
                        md: settings.pinSidebar ? '250px' : '73px'
                    },
                    transition: 'margin-left 250ms cubic-bezier(0.4, 0, 0.2, 1)'
                }}
            >
                <ButtonAppBar onMobileNavOpen={() => setMobileOpen(true)} />
                <DashboardLayoutContent>
                    <Outlet />
                    <Footer />
                </DashboardLayoutContent>
            </Box>
        </Box>
    );
};
